// TODO(): type OutputAction payloads
export enum OutputAction {
  Handshake = 'Handshake',
  Logout = 'Logout',
  Restart = 'Restart',
  Downloads_GetAll = 'Downloads_GetAll',
  Downloads_Start = 'Downloads_Start',
  Download_Start = 'Download_Start',
  Download_Delete = 'Download_Delete',
  Downloads_Delete = 'Downloads_Delete',
  Download_Pause = 'Download_Pause',
  Download_Resume = 'Download_Resume',
  Download_Play = 'Download_Play',
  Download_Cancel = 'Download_Cancel',
  Downloads_Cancel = 'Downloads_Cancel',
  Download_Retry = 'Download_Retry',
  Settings_GetAll = 'Settings_GetAll',
  Settings_DownloadQuality = 'Settings_DownloadQuality',
  Settings_DownloadOnMobileData = 'Settings_DownloadOnMobileData',
  Settings_3PNotice = 'Settings_3PNotice',
  Settings_Feedback = 'Settings_Feedback',
  Profile_Switch = 'Profile_Switch',
  Profile_Switched = 'Profile_Switched',
  Profile_SwitchFailed = 'Profile_SwitchFailed',
  Counter = 'Counter',
  Logging = 'Logging',
  AppCapabilities_GetAll = 'AppCapabilities_GetAll'
}

export enum MetricSystem {
  SW = 'SW',
  SPA = 'SPA'
}

export enum MetricLevel {
  VERBOSE = 'Verbose',
  DEBUG = 'Debug',
  INFO = 'Information',
  WARN = 'Warning',
  ERROR = 'Error',
  FATAL = 'Fatal'
}

export interface AuxCounters {
  [key: string]: number
}

export interface LoggingData {
  [key: string]: string
}

export interface CounterPayload {
  scope: string
  system: MetricSystem
  auxCounters?: AuxCounters
}

export interface LoggingPayload {
  message: string
  level: MetricLevel
  system: MetricSystem
  data?: LoggingData
}
